import _ from "lodash";
import { MenuItem, Select } from '@mui/material';
import { OptionsStore } from "../../../common/OptionsLoader";
import ExcelImportStore from "../ExcelImportStore";

type Props = {
    id: string,
    value: string,
}

const IndustryColumn = ({ id, value }: Props) => {
    const options = OptionsStore.useState(s => s.industries);

    const onChange = (e: any) => {
        ExcelImportStore.update((s, o) => {       
            const temp = _.cloneDeep(o.leads);

            const option = options.find(s => s.value === e.target.value);
            
            if (option) {
                const rowIndex = temp.findIndex(s => s.id === id);
                const record = temp[rowIndex];

                record.industryId = option.value;
                record.industryName = option.name;                
                record.industryIdError = false;
                s.leads = temp;
            }
        })
    }

    return <Select
        size='small'
        fullWidth
        value={value}
        onChange={onChange}
    >
        {options.map(item => <MenuItem value={item.value}>{item.name}</MenuItem>)}
    </Select>
}

export { IndustryColumn }
export default IndustryColumn;